import { render, staticRenderFns } from "./SlotSelector.vue?vue&type=template&id=63c2181a&"
import script from "./SlotSelector.vue?vue&type=script&lang=js&"
export * from "./SlotSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports